import { render, staticRenderFns } from "./Refunds.vue?vue&type=template&id=35e1e274&"
import script from "./Refunds.vue?vue&type=script&lang=js&"
export * from "./Refunds.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports